var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysSave = function SvgSysSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.999 14.002v-.035H3.717a1.716 1.716 0 0 1-1.586-1.055A1.714 1.714 0 0 1 2 12.256V6.129c0-.453.18-.888.5-1.21L4.922 2.5c.322-.322.759-.501 1.213-.501h6.146a1.71 1.71 0 0 1 1.717 1.707v8.549a1.713 1.713 0 0 1-1.717 1.71h-1.213V14l-6.069.002Zm7.286-1.037a.711.711 0 0 0 .715-.71V3.708a.711.711 0 0 0-.715-.705h-1.288v1.5a1.627 1.627 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.665.665 0 0 0 .5-.5v-1.5H6.138a.72.72 0 0 0-.508.207L3.208 5.625a.714.714 0 0 0-.207.5v6.127a.715.715 0 0 0 .21.504.707.707 0 0 0 .505.205h1.282V9.998a1 1 0 0 1 1-1h4.075a1 1 0 0 1 1 1v2.963l1.212.004Zm-2.21 0v-2.963H6v2.963h4.075Z"
  })));
};
export default SvgSysSave;